/* ============================================================
   TieTiè Sartoriale — interazioni (v1.1)
   ============================================================ */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  /* ---------- Reveal on scroll (riutilizzabile anche dopo AJAX) ---------- */
  var revealIO = null;
  function observeReveals(scope) {
    var els = $$('.reveal:not(.is-in)', scope || document);
    if (!els.length) return;
    if (reduced || !hasIO) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealIO.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (el) { revealIO.observe(el); });
  }

  /* ---------- Toast & contatore carrello ---------- */
  var toastTimer;
  function showToast(msg) {
    var toast = $('#toast');
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2800);
  }
  function refreshCartCount() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      $$('[data-cart-count]').forEach(function (b) {
        b.textContent = cart.item_count;
        b.classList.toggle('hide', cart.item_count === 0);
      });
    });
  }

  /* ---------- Quick-add dalle card (delegato: funziona anche dopo caricamenti AJAX) ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[data-quick-add]')) return;
    e.preventDefault();
    var btn = f.querySelector('button');
    if (btn) btn.classList.add('is-loading');
    fetch('/cart/add.js', { method: 'POST', body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return refreshCartCount(); })
      .then(function () { showToast('Aggiunto al carrello ✓'); })
      .catch(function () { HTMLFormElement.prototype.submit.call(f); })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  });

  document.addEventListener('DOMContentLoaded', function () {

    /* ---------- Header: ombra allo scroll ---------- */
    var header = $('.site-header');
    var onScroll = function () {
      if (header) header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* ---------- Drawer menu mobile + pannello filtri ---------- */
    var drawer = $('#drawer');
    var overlay = $('#overlay');
    var filtersAside = $('#coll-filters');

    function lockScroll(lock) { document.body.classList.toggle('no-scroll', lock); }
    function openDrawer() {
      if (!drawer) return;
      drawer.classList.add('open');
      if (overlay) overlay.hidden = false;
      lockScroll(true);
    }
    function closeDrawer() {
      if (drawer) drawer.classList.remove('open');
      if (filtersAside) filtersAside.classList.remove('open');
      if (overlay) overlay.hidden = true;
      lockScroll(false);
    }
    function openFilters() {
      if (!filtersAside) return;
      filtersAside.classList.add('open');
      if (overlay) overlay.hidden = false;
      lockScroll(true);
    }

    $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
    $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    $$('[data-filters-open]').forEach(function (b) { b.addEventListener('click', openFilters); });
    $$('[data-filters-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    if (overlay) overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    /* ---------- Barra annunci: rotazione ---------- */
    var ann = $('[data-ann]');
    if (ann && !reduced) {
      var items = $$('[data-ann-item]', ann);
      if (items.length > 1) {
        var i = 0;
        setInterval(function () {
          items[i].classList.remove('is-active');
          i = (i + 1) % items.length;
          items[i].classList.add('is-active');
        }, 4200);
      }
    }

    /* ---------- Reveal ---------- */
    observeReveals(document);

    /* ---------- Galleria prodotto ---------- */
    $$('[data-gallery]').forEach(function (g) {
      var main = $('[data-gallery-main]', g);
      if (!main) return;
      $$('[data-gallery-thumb]', g).forEach(function (t) {
        t.addEventListener('click', function () {
          main.src = t.getAttribute('data-full');
          main.removeAttribute('srcset');
          $$('[data-gallery-thumb]', g).forEach(function (x) { x.classList.toggle('is-active', x === t); });
        });
      });
    });

    /* ---------- Stepper quantità ---------- */
    $$('[data-qty]').forEach(function (w) {
      var input = w.querySelector('input');
      if (!input) return;
      $$('button', w).forEach(function (b) {
        b.addEventListener('click', function () {
          var d = parseInt(b.getAttribute('data-qty-delta'), 10) || 0;
          var min = parseInt(input.getAttribute('min') || '1', 10);
          input.value = Math.max(min, (parseInt(input.value, 10) || min) + d);
          if (input.hasAttribute('data-autosubmit') && input.form) HTMLFormElement.prototype.submit.call(input.form);
        });
      });
    });
    $$('input[data-autosubmit]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        if (inp.form) HTMLFormElement.prototype.submit.call(inp.form);
      });
    });

    /* ---------- Pagina prodotto: codice sconto quantità ---------- */
    var pdpForm = $('[data-pdp-form]');
    if (pdpForm) {
      var code = pdpForm.getAttribute('data-discount-code');
      var minQty = parseInt(pdpForm.getAttribute('data-discount-min') || '0', 10);
      if (code && minQty > 0) {
        pdpForm.addEventListener('submit', function (e) {
          var qEl = pdpForm.querySelector('input[name="quantity"]');
          var q = qEl ? (parseInt(qEl.value, 10) || 1) : 1;
          if (q < minQty) return; /* flusso normale */
          e.preventDefault();
          fetch('/cart/add.js', { method: 'POST', body: new FormData(pdpForm) })
            .then(function () {
              window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
            })
            .catch(function () { HTMLFormElement.prototype.submit.call(pdpForm); });
        });
      }
    }

    /* ---------- Widget «Risparmia con il set» ---------- */
    var qb = $('[data-qty-break]');
    if (qb && pdpForm) {
      var basePrice = parseInt(qb.getAttribute('data-price'), 10) || 0;
      var qtyInput = pdpForm.querySelector('input[name="quantity"]');
      var atcPrice = $('[data-atc-price]');
      var fmt = function (cents) {
        var n = (cents / 100).toFixed(2).split('.');
        return n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + n[1] + ' €';
      };
      qb.addEventListener('change', function (e) {
        var opt = e.target;
        if (!opt.name || opt.name.indexOf('qb-') !== 0) return;
        var qty = parseInt(opt.value, 10) || 1;
        var pct = parseInt(opt.getAttribute('data-pct') || '0', 10);
        if (qtyInput) qtyInput.value = qty;
        if (atcPrice && basePrice) {
          atcPrice.textContent = fmt(Math.round(basePrice * qty * (100 - pct) / 100));
        }
      });
    }

    /* ---------- Consegna stimata (1–4 giorni lavorativi) ---------- */
    var del = $('[data-delivery]');
    if (del) {
      try {
        var addBiz = function (from, n) {
          var d = new Date(from.getTime());
          while (n > 0) {
            d.setDate(d.getDate() + 1);
            if (d.getDay() !== 0 && d.getDay() !== 6) n--;
          }
          return d;
        };
        var fmtDate = new Intl.DateTimeFormat('it-IT', { weekday: 'long', day: 'numeric', month: 'long' });
        var now = new Date();
        $('[data-delivery-range]', del).textContent = fmtDate.format(addBiz(now, 1)) + ' e ' + fmtDate.format(addBiz(now, 4));
        del.hidden = false;
      } catch (err) { /* resta nascosto */ }
    }

    /* ---------- Barra ATC sticky (pagina prodotto) ---------- */
    var atcBar = $('[data-atc-bar]');
    if (pdpForm && atcBar && hasIO) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        atcBar.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(pdpForm);
    }

    /* ============================================================
       Collezione: filtri AJAX + caricamento progressivo
       ============================================================ */
    var filterForm = $('[data-filter-form]');
    var results = $('[data-results]');
    var SECTION_ID = 'main';
    var infiniteIO = null;
    var loadingNext = false;

    function loadNext() {
      var sentinel = $('[data-sentinel]');
      if (!sentinel || sentinel.hidden || loadingNext || !sentinel.dataset.next) return;
      loadingNext = true;
      var spinner = $('[data-spinner]', sentinel);
      var btn = $('[data-load-more]', sentinel);
      if (spinner) spinner.hidden = false;
      if (btn) btn.hidden = true;
      var url = sentinel.dataset.next + (sentinel.dataset.next.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + SECTION_ID;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = $('[data-grid]');
          var freshGrid = doc.querySelector('[data-grid]');
          if (grid && freshGrid) {
            Array.prototype.forEach.call(freshGrid.children, function (node) {
              grid.appendChild(document.importNode(node, true));
            });
            observeReveals(grid);
          }
          var freshSent = doc.querySelector('[data-sentinel]');
          if (freshSent && freshSent.dataset.next) {
            sentinel.dataset.next = freshSent.dataset.next;
          } else {
            sentinel.hidden = true;
          }
        })
        .catch(function () {})
        .finally(function () {
          loadingNext = false;
          if (spinner) spinner.hidden = true;
          if (btn) btn.hidden = false;
        });
    }

    function initInfinite() {
      var sentinel = $('[data-sentinel]');
      var pag = $('[data-pagination]');
      if (pag) pag.hidden = true;
      if (!sentinel) return;
      if (sentinel.dataset.next) sentinel.hidden = false;
      var btn = $('[data-load-more]', sentinel);
      if (btn && !btn.dataset.bound) {
        btn.dataset.bound = '1';
        btn.addEventListener('click', loadNext);
      }
      if (infiniteIO) infiniteIO.disconnect();
      if (!reduced && hasIO && sentinel.dataset.next) {
        infiniteIO = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) loadNext();
        }, { rootMargin: '700px 0px' });
        infiniteIO.observe(sentinel);
      }
    }

    if (filterForm && results) {
      var applyBtn = $('[data-filter-apply]', filterForm);
      if (applyBtn) applyBtn.hidden = true;

      var debounceT;
      filterForm.addEventListener('change', function () {
        clearTimeout(debounceT);
        debounceT = setTimeout(ajaxApply, 300);
      });
      filterForm.addEventListener('submit', function (e) {
        e.preventDefault();
        ajaxApply();
      });

      function ajaxApply() {
        var params = new URLSearchParams();
        new FormData(filterForm).forEach(function (v, k) {
          if (String(v).trim() !== '') params.append(k, v);
        });
        var qs = params.toString();
        if (history.replaceState) {
          history.replaceState({}, '', filterForm.action + (qs ? '?' + qs : ''));
        }
        var fetchParams = new URLSearchParams(qs);
        fetchParams.set('section_id', SECTION_ID);
        results.classList.add('is-loading');
        fetch(filterForm.action + '?' + fetchParams.toString())
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-results]');
            if (!fresh) throw new Error('no results');
            results.innerHTML = fresh.innerHTML;
            observeReveals(results);
            initInfinite();
          })
          .catch(function () { HTMLFormElement.prototype.submit.call(filterForm); })
          .finally(function () { results.classList.remove('is-loading'); });
      }
    }

    initInfinite();
  });
})();
